import React from 'react';
import pull = require("lodash/pull");
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import mdEntityService from 'core/metamodel/mdEntityService';
import MdField, {DATATYPE} from 'core/metamodel/mdField';
import Form from 'core/form/form';
import {createForm} from 'core/form/createForm';
import StyledDatePicker from 'core/components/fields/styledDatePicker';
import StyledDateInterval from "core/components/fields/styledDateInterval";
import StyledSelect from 'core/components/fields/styledSelect';
import NumberField from 'core/components/fields/numberField';
import {MdCheckbox} from 'core/components/fields/fields';
import {Validate} from 'core/form/validate';
import {DEFAULT_CURRENCY_FORMAT} from 'core/common/utils/numberUtils';
import productService from 'product/productService';
import {ErrorComp} from 'core/components/errorComp/errorComp';
import SvgDelete = require('react-icons/lib/md/delete');
import {MdIconButton} from "core/components/buttons/icons";
import Add from "material-ui/svg-icons/content/add";
import Grid, {GridParams} from "core/grid/domain/grid";
import {LovItem} from "core/metamodel/mdEntity";
import {observable, action} from "mobx";
import {DomainAncestor, entityConfig, fieldInfo} from "core/common/domain/DomainAncestor";
import commonService from "core/common/service/commonService";
import {FormProps, lovLabel, lovValue} from "core/form/formUtils";
import {observer} from "mobx-react";
import {
  DialogProps, DialogAncestor, entityStatusCss, validationMessageCss,
  entityStatusText, SteppingDialogAncestor
} from "core/common/page/dialogAncestor";
import {FIELDDEFDISPLAYTYPE} from "core/form/form";
import {SEVERITY} from "core/common/domain/commonDomain";
import {
  Step,
  Stepper,
  StepLabel,
} from 'material-ui/Stepper';
import securityService from "core/security/securityService";
import {MODULE, PERMISSION, SECURABLE, SECURABLE_TYPE} from "core/metamodel/metaConstant";
import {EntityStatus} from "core/event/eventDomain";
import {optionsSearch} from "core/common/service/commonDataService";
import {addTenantToQuery} from "core/common/utils/utils";
import {Link} from 'react-router';



@entityConfig()
class PVADProductDto extends DomainAncestor {
  @observable price?: number;
  @observable product?: LovItem;
  @observable validFrom?: string|Date;
  @observable validTo?: string|Date;
  @observable priceValidFrom?: string|Date;
  @observable setValidityFrom?: boolean;
  @observable setValidityTo?: boolean;
}

@entityConfig()
export class PVADObjectDto extends DomainAncestor {
  @observable @fieldInfo(PVADProductDto) products: PVADProductDto[];
  @observable gridParams: GridParams;
  @observable @fieldInfo(EntityStatus) vehicleStatuses: EntityStatus[];
  @observable part: number;
  @observable showErrors: boolean;
  @observable showNoOp: boolean;
  @observable selectedCount: number;

  constructor(json: any) {
    super(json);
  }

  toBeModifiedVehicleCount() : number {
    return (this.vehicleStatuses && this.vehicleStatuses.length) ? this.vehicleStatuses.filter(cs => cs.status !== SEVERITY.ERROR && cs.status !== SEVERITY.NOOP).length : 0;
  }

}


@observer
export default class ProductVehicleAssignDialog extends SteppingDialogAncestor<DialogProps, undefined, string> {

  @observable public PVADObject: PVADObjectDto;


  @action open(resolve, reject, grid: Grid) {

    let gridParams = grid.createFullParams();

    console.log('ProductVehicleAssignDialog: Opening dialog for ', gridParams);

    this.resolve = resolve;
    this.reject = reject;

    mdEntityService.fetchEntityMetadata(['ProductVehicle'])
      .then(action("open-callback", (entities) => {
        this.PVADObject = new PVADObjectDto({
          products: [new PVADProductDto()],
          gridParams: gridParams,
          selectedCount: grid.getSelectedCount(),
          vehicleStatuses: [],
          part: 1,
          showErrors: null
        });

        this.dialogOpen = true;
      }));
  }



  _customValidateForm = (product: PVADProductDto): boolean => {
    this.$errors = [];
    if (product.price == null && product.priceValidFrom) {
      this.$errors.push({message: "Price validFrom cannot be specified without price"})
    }
    return !this.hasErrors();
  };


  @action prepare = () => {
    let res: boolean = true;
    for(let product of this.PVADObject.products) {
      let form: Form<PVADProductDto> = product.getForm("PVAForm");
      res = form.validateForm(product) && res;
      res = this._customValidateForm(product) && res;
    }

    if (!res) return;


    commonService.loading(true);
    productService.assignProducts(this.PVADObject, 1).then((newPVADObject: PVADObjectDto) => {
      commonService.loading(false);
      this.PVADObject.part = 2;
      this.PVADObject.showErrors = true;
      this.PVADObject.vehicleStatuses = newPVADObject.vehicleStatuses;
    }, error => {
      this.$errors = error.getMessages();
    });

  };

  @action ok = () => {

    commonService.loading(true);
    productService.assignProducts(this.PVADObject, 2).then((newPVADObject: PVADObjectDto) => {
      commonService.loading(false);
      this.PVADObject.part = 3;
      this.PVADObject.showErrors = false;
      this.PVADObject.vehicleStatuses = newPVADObject.vehicleStatuses;
    }, error => {
      this.$errors = error.getMessages();
    });

  };

  @action onShowErrors = (evt) => {
    this.PVADObject.showErrors = evt.target.checked;
  };


  @action onShowNoOp = (evt) => {
    this.PVADObject.showNoOp = evt.target.checked;
  };

  @action cancel = () => {
    this.dialogOpen = false;
    this.reject("cancel");
  };

  @action close = () => {
    this.PVADObject = null;
    this.resolve(null);
  };

  @action addProduct = (evt) => {
    this.PVADObject.products.push(new PVADProductDto());
  };


  render() {

    if (!(this.PVADObject && this.dialogOpen)) return null;

    let issuableCount =  this.PVADObject.toBeModifiedVehicleCount();

    let cancelButton = <FlatButton key="cancel" label="Cancel" tabIndex={0} primary onClick={this.cancel} />;
    let showErrorCheckbox = <MdCheckbox key="showErrors" label="Show Errors" checked={this.PVADObject.showErrors} labelStyle={{whiteSpace: 'nowrap'}} style={{display: 'inline-block', width: 140, verticalAlign: 'middle'}} onCheck={this.onShowErrors} />;
    let showNoOpCheckbox = <MdCheckbox key="showUnmodified" label="Show Unmodified" checked={this.PVADObject.showNoOp} labelStyle={{whiteSpace: 'nowrap'}} style={{display: 'inline-block', width: 170, verticalAlign: 'middle'}} onCheck={this.onShowNoOp} />;

    let actions;

    if (this.PVADObject.part === 1) {
      actions = [cancelButton, <FlatButton key="check" label="Check" secondary onClick={this.prepare}/>];
    } else if (this.PVADObject.part === 2) {
      actions = [showErrorCheckbox,showNoOpCheckbox, cancelButton,
        <FlatButton key="recheck" label="Recheck" secondary onClick={this.prepare}/>, <FlatButton key="assignProducts" label="Assign Products !" secondary onClick={this.ok} disabled={issuableCount === 0}/>];
    } else if (this.PVADObject.part === 3) {
      actions = [showErrorCheckbox,showNoOpCheckbox, <FlatButton key="close" label="Close" primary onClick={this.close} />];
    }



    return (
      <Dialog
        actions={actions}
        modal={true}
        open={this.dialogOpen}
        autoScrollBodyContent={true}
        bodyStyle={{minHeight: 400}}
        contentStyle={{position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', filter: 'blur(0)', width: '80%', maxWidth: 'none'}}
      >

        <Stepper activeStep={this.PVADObject.part - 1}>
          <Step>
            <StepLabel className="mui-stepper-icon-hack"> {`Check (${this.PVADObject.selectedCount})`} </StepLabel>
          </Step>
          <Step>
            <StepLabel className="mui-stepper-icon-hack"> { `Assign products (${issuableCount})` } </StepLabel>
          </Step>
          <Step>
            <StepLabel className="mui-stepper-icon-hack"> { `Done (${ (this.PVADObject.part === 3) ? issuableCount : 0})` }  </StepLabel>
          </Step>
        </Stepper>

        <ErrorComp messages={this.$errors}/>

        {
          (this.PVADObject.part === 1) ? (
            <div>
              {
                this.PVADObject.products.map( (product, index) => {
                  return <PVAForm entities={mdEntityService.entityMap} key={index} index={index} entity={mdEntityService.getEntity('ProductVehicle')} dataObject={product} rootObject={this.PVADObject} />
                } )
              }

              <div className="row">
                <h5 style={{display: 'flex', alignItems: 'center', margin:'0 0 0 5px', fontSize:18}}>
                  <span>Add Product</span>
                  <MdIconButton onClick={this.addProduct}>
                    <Add />
                  </MdIconButton>
                </h5>
              </div>
            </div>
          ) : (
            <div style={{overflowY: 'auto', maxHeight:500}}>
              <table className="table table-condensed fullwrap">
                <tbody>
                  {this.PVADObject.vehicleStatuses.filter( is => (this.PVADObject.showNoOp || is.status !== SEVERITY.NOOP) && (this.PVADObject.showErrors || is.status !== SEVERITY.ERROR) ).map( (is, index) => {
                    let _className = entityStatusCss(is);
                    return (
                      <tr key={index}>
                        <td>
                          <Link to="vehicleDetail" params={{id: lovValue(is.entityObject)}}  query={addTenantToQuery()}><span className={_className}>{lovLabel(is.entityObject)}</span></Link>
                          { (is.messages && is.messages.length) ? (
                            <table style={{marginLeft: 20}}>
                              <tbody>
                              {is.messages.map( (messageObj, index) => (
                                <tr key={index}><td className={validationMessageCss(messageObj)}>{messageObj.message}</td></tr>
                              ))}
                              </tbody>
                            </table>
                          ) : null}
                        </td>
                        <td className={_className}>
                          {entityStatusText(is)}
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          )
        }


      </Dialog>
    );
  }


}


@createForm({
  formName: 'PVAForm',
  fields: [{
    name: 'product',
    validators: ['IsRequired']
  }, {
    name: 'validFrom',
    label: "Product dates"
  }, {
    name: 'validTo'
  }, {
    name: 'price',
    validators: ['IsNumber'],
    mdField: new MdField({label: 'Price', numberFormat: DEFAULT_CURRENCY_FORMAT, dataType: DATATYPE.NUMBER })
  }, {
    name: 'priceValidFrom',
    mdField: new MdField({label: 'Price Valid from', dataType: DATATYPE.DATE })
  }, {
    name: 'setValidityFrom',
    mdField: new MdField({label: 'Set Product From', dataType: DATATYPE.BOOLEAN }),
    displayType: FIELDDEFDISPLAYTYPE.checkbox
  }, {
    name: 'setValidityTo',
    mdField: new MdField({label: 'Set Product To', dataType: DATATYPE.BOOLEAN }),
    displayType: FIELDDEFDISPLAYTYPE.checkbox
  }]
}, () => <noscript/>)
@observer
class PVAForm extends React.Component<FormProps<PVADProductDto, PVADObjectDto>, undefined> {

  onDelete = (evt) => {
    let {dataObject, rootObject} = this.props;
    evt.stopPropagation();
    console.log('onDelete %o', dataObject);
    pull(rootObject.products, dataObject);
  };


  render() {

    let {dataObject, rootObject, entities, index, formName} = this.props;
    let {price, product, validFrom, validTo, priceValidFrom, setValidityFrom, setValidityTo} = dataObject.getFormFields(formName);

    const checkboxLabelStyle = Object.assign({whiteSpace:'nowrap'}, setValidityFrom.props.labelStyle);
    const checkboxStyle = Object.assign({}, setValidityFrom.props.style, {paddingTop: 0});

    const withPricePermission = securityService.hasRight(SECURABLE.assignProductsCustomPrice.name, PERMISSION.Execute);

    return (
        <div style={{display: 'flex'}}>
          <div style={{marginRight:10, flexGrow: 3}}>
            <StyledSelect {...product.props} async loadOptions={optionsSearch.bind(this, 'Product', {})} clearable asterixForAll/>
            <Validate field={product} value={product.props.value}/>
          </div>

          <div style={{paddingRight:10}}>
            <MdCheckbox {...setValidityFrom.props}  iconStyle={{marginRight:2}} labelStyle={checkboxLabelStyle} style={checkboxStyle}
                        label={setValidityFrom.props.label} />
            <MdCheckbox {...setValidityTo.props}  iconStyle={{marginRight:2}} labelStyle={checkboxLabelStyle} style={checkboxStyle}
                        label={setValidityTo.props.label} />
          </div>

          {(dataObject.setValidityFrom || dataObject.setValidityTo) ?
          <div style={{marginRight:10, flexGrow: 1}}>
            <StyledDateInterval {...validFrom.props} valueFrom={validFrom.props.value} valueTo={validTo.props.value}
                                onChangeFrom={validFrom.props.onChange} onChangeTo={validTo.props.onChange} />
          </div> : null}

          {(withPricePermission) ? (
            <div style={{marginRight:10, flexGrow: 1}}>
              <NumberField {...price.props} />
              <Validate field={price} value={price.props.value}/>
            </div>
          ) : null}
          {(withPricePermission) ? (
            <div style={{marginRight:10, flexGrow: 1}}>
              <StyledDatePicker {...priceValidFrom.props}  />
            </div>
          ) : null}

          <MdIconButton style={{alignSelf: 'center'}} onClick={this.onDelete} disabled={!index}>
            <SvgDelete size={24}/>
          </MdIconButton>

        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/product/component/productVehicleAssignDialog.tsx